import apiServices from "@/services/yungol-services";
import { parseUsersBlock } from "./helpers";

export const fetchUsersBlock = async (params) => {
  const response = await apiServices.get("/users", { params });

  if (response.status !== 200) {
    throw new Error("Error fetching users");
  }

  return parseUsersBlock(response.data);
};

export const deleteUser = async (id) => {
  const response = await apiServices.delete(`/users/${id}`);

  return response.data;
};

export const sendPasswordLink = async (id) => {
  const response = await apiServices.post(`/users/${id}/password-link`);

  return response.data;
};



// WEBPACK FOOTER //
// ./src/components/users/api.js